import { render, staticRenderFns } from "./Awardgfreview.vue?vue&type=template&id=c4d0f5b8&scoped=true"
import script from "./Awardgfreview.vue?vue&type=script&lang=js"
export * from "./Awardgfreview.vue?vue&type=script&lang=js"
import style0 from "./Awardgfreview.vue?vue&type=style&index=0&id=c4d0f5b8&prod&lang=css"
import style1 from "./Awardgfreview.vue?vue&type=style&index=1&id=c4d0f5b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d0f5b8",
  null
  
)

export default component.exports